<template>
  <select
    class="calendar-select"
    :class="{thinner}"
    @change="changeMonth">
    <option
      v-for="(month_name, key) in month_names"
      :selected="selected_month === key"
      :value="key">
      {{ $t(`vacations.${month_name}`) }}
    </option>
  </select>
</template>

<script>

export default {
  name: "MonthSelect",
  emits: ["changeMonth"],
  props: {
    // as month index
    selected_month: {
      type: Number,
      default: 0
    },
    thinner: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    month_names() {
      return [
        'january', 'february', 'march', 'april', 'may', 'june', 'july',
        'august', 'september', 'october', 'november', 'december'
      ]
    },
  },
  data() {
    return {
      selected_month_local: null,
    }
  },
  mounted() {
    this.selected_month_local = this.selected_month
  },
  methods: {
    changeMonth({target}) {
      this.selected_month_local = Number(target.value);
      this.$emit('changeMonth', this.selected_month_local);
    }
  },
  watch: {
    'selected_month'(val) {
      this.selected_month_local = val;
    }
  }
}
</script>
